import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/ThumbDownFill.tsx
const ThumbDownFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M13 21.008a3 3 0 0 0 2.995-2.824l.005-.176v-4h2a3 3 0 0 0 2.98-2.65l.015-.174.005-.176-.02-.196-1.006-5.032c-.381-1.626-1.502-2.796-2.81-2.78L17 3.008H9a1 1 0 0 0-.993.883L8 4.008l.001 9.536a1 1 0 0 0 .5.865 2.998 2.998 0 0 1 1.492 2.397l.007.202v1a3 3 0 0 0 3 3ZM5 14.008a1 1 0 0 0 .993-.883L6 13.008v-9a1 1 0 0 0-.883-.993L5 3.008H4a2 2 0 0 0-1.995 1.85L2 5.008v7a2 2 0 0 0 1.85 1.995l.15.005h1Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { ThumbDownFillIcon };
